// Akahu account reference-data endpoint.

import { apiFetch } from './client';
import type { Account } from './types';

// List the user's Akahu accounts (reference data, refreshed by the ingest).
export async function getAccounts(): Promise<Account[]> {
	return apiFetch<Account[]>('/accounts');
}
